module.exports = __webpack_public_path__ + "static/media/financecase3.0eea411d.png";